import * as vp from 'vopay';
import styles from './AvailableBalance.module.scss';

type AvailableBalanceProps = {
  availableBalance: string;
};

const AvailableBalance: React.FC<AvailableBalanceProps> = ({ availableBalance }) => {
  return (
    <div className={styles.BalanceView}>
      <span className={styles.BalanceViewLabel}>Available Balance:</span> {vp.formattedCurrency(availableBalance)}
    </div>
  );
};

export default AvailableBalance;
